<template>
<div>
  <bar-graph
    :height="300"
    :data="data"
    />
</div>
</template>
<script>
import dataLog from 'services/dataLog.js'
import BarGraph from './BarGraph.vue'

export default {
  components: { BarGraph },
  mounted () {
    dataLog.getSetupLog()
  },
  computed: {
    setupLog () {
      return this.$store.getters.setupLog
    },
    data () {
      const data = {
        labels: [],
        datasets: [{
          label: 'Load time',
          backgroundColor: '#f87979',
          data: []
        }]
      }

      console.log(this.setupLog)

      const stepsTotal = {}
      const ignore = { 'timestamp': true, 'start': true, 'serialNumber': true }
      this.setupLog
        .filter(steps => steps.scanning < 1000)
        .forEach(steps => {
          Object.entries(steps).forEach(([step, duration]) => {
            if (typeof duration === 'number' && !ignore[step]) {
              if (!stepsTotal[step]) {
                stepsTotal[step] = {
                  duration: 0,
                  quantity: 0
                }
              }

              stepsTotal[step].duration += duration / 1000
              stepsTotal[step].quantity++
            }
          })
        })

      Object.entries(stepsTotal).forEach(([step, stepData]) => {
        const duration = Math.round(stepData.duration / stepData.quantity)

        data.labels.push(step)
        data.datasets[0].data.push(duration)
      })

      console.log(stepsTotal)

      return data
    }
  }
}
</script>
